module.exports = __webpack_public_path__ + "img/circle-check-solid.d8011fa.svg";